import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router-dom'

import { Footer, Header, Scroller, Toaster } from '@/shared'
import { useCheckAuth, useEnvironment } from '@App/hooks'

import style from './styles/layout.module.scss'

export const Layout = observer(() => {
    const isAuth = useCheckAuth()
    useEnvironment()
    return (
        <div className={style.container}>
            {isAuth && <Header />}
            <Outlet />
            <Toaster />
            {isAuth && <Footer />}
            <Scroller />
        </div>
    )
})
